export const formInputLight = {
  height: 44,
  backgroundColor: 'grey/light/background',
  color: 'primary/text',
  labelVariant: 'p1',
  borderRadius: 'xl',
  paddingLeft: 'm',
  paddingRight: 'm',
  paddingBottom: 'none',
  placeholderVariant: 'p1',
  placeholderPropsStyle: {
    color: 'grey/light',
    paddingLeft: 'm',
    paddingRight: 'm',
  },
  labelPropsStyle: {
    color: 'primary/text',
  },
  colorOnFocus: 'primary/text',
  py: 'none',
  inputTextStyle: {
    fontSize: 'm',
    color: 'primary/text',
  },
};
